import styled from "styled-components";
import { CaptionText, LittleSubHeadline, LittleText } from "../typography";
import { COLORS } from "../../assets/utils/enums/colors";
import copyIcon from '../../assets/images/icons/copy-icon.svg';
import doneIcon from '../../assets/images/icons/done-icon-white.svg'
import { Button } from "./button";
import { useState } from "react";

export default function SendInviteBlock({ link }: { link: string }) {
    const [isCopied, setIsCopied] = useState<boolean>(false);

    return (
        <SendBlockStyle className="d-flex flex-column gap-2 w-100">
            <CaptionText>Запрошувальне посилання</CaptionText>
            <LittleText>Користувач, що перейде за посиланням, зможе приєднатися до вашої команди</LittleText>
            <span className="d-flex gap-1 justify-content-between">
                <input value={link} onChange={() => link} />
                <Button bgcolor={isCopied ? COLORS.blue : COLORS.white}
                    txtcolor={isCopied ? COLORS.white : COLORS.secondary1}
                    brcolor={isCopied ? COLORS.blue : COLORS["light-gray"]}
                    width="auto"
                    brradius="24px"
                    type="large" onClick={async () => {
                        try {
                            await navigator.clipboard.writeText(link);
                            setIsCopied(true);
                            setTimeout(() => setIsCopied(false), 1500);
                        } catch (err) {
                            console.error("Failed to copy text: ", err);
                        }
                    }}>
                    <img src={isCopied ? doneIcon : copyIcon}
                        alt="copy-icon" />
                    <LittleSubHeadline>Копіювати</LittleSubHeadline>
                </Button>
            </span>
        </SendBlockStyle>
    )
}

const SendBlockStyle = styled.div`
    border-radius: 12px;
    padding: 20px;
    background-color: ${COLORS.gray};

    ${CaptionText} {
        color: ${COLORS.secondary1};
    }

    ${LittleText} {
        color: ${COLORS["bg-text-color"]};
    }

    input {
        background-color: ${COLORS.white};
        padding: 12px 20px;
        border-radius: 24px;
        color: ${COLORS["bg-text-color"]};
        width: 77%;
        outline: none;
        border: none;
    }

    ${Button} {
        gap: 4px;
        img {
            width: 20px;
            height: 20px;
        }
    }
`